import { LandClass, EconRule, SoilModifier } from '../types';

export const MAP_M = 2000;
export const HA = 10000;
export const GRID = 5;

export const CLASSES: LandClass[] = [
  { id: 'grass', label: 'Grassland', fill: '#8FBE6B', ink: '#3E5C2A' },
  { id: 'crop', label: 'Cropland', fill: '#E8C547', ink: '#7A5E10' },
  { id: 'forestry', label: 'Forestry', fill: '#1F4A25', ink: '#0D2410' },
  { id: 'wetland', label: 'Wetland / Peatland', fill: '#8B6544', ink: '#4A3320' },
  { id: 'urban', label: 'Urban', fill: '#C0392B', ink: '#5C1A12' },
  { id: 'water', label: 'Water', fill: '#4A90E2', ink: '#1E3A5F' }, 

];

export const CLASS_BY_ID = Object.fromEntries(
  CLASSES.map((c) => [c.id, c])
) as Record<string, LandClass>;

export const RULES: Record<string, EconRule> = {
  grass: { econ: 3000, carbon: 4, bio: 20 },
  crop: { econ: 1000, carbon: 2, bio: 25 },
  forestry: { econ: 250, carbon: -3, bio: 30 },
  wetland: { econ: 0, carbon: -2, bio: 70 },
  urban: { econ: 0, carbon: 6, bio: -25 },
  water: { econ: 0, carbon: 0, bio: 50 }, 
};

export const SOIL_MOD: Record<string, SoilModifier> = {
  grass: { organic: 20, mineral: 0 },
  crop: { organic: -5, mineral: 15 },
  forestry: { organic: 15, mineral: 0 },
  wetland: { organic: 0, mineral: 0 },
  urban: { organic: 0, mineral: 0 },
  water: { organic: 0, mineral: 0 },
};